import type { GraphEdge, GraphRelationshipReminder, GraphVisualizationFrame } from "@salesko/contracts";

export type ReminderWorkspaceAction =
  | { kind: "log_touchpoint"; edge: GraphEdge }
  | { kind: "open_frame"; frameRecordId: string; nodeId: string };

export function reminderWorkspaceAction(
  reminder: GraphRelationshipReminder,
  currentFrameRecordId: string | null,
  frame: GraphVisualizationFrame | null,
  selectedNodeId: string
): ReminderWorkspaceAction {
  if (currentFrameRecordId && reminder.edge.frameRecordId === currentFrameRecordId) {
    const frameEdge = frame?.graph.edges.find((candidate) => candidate.id === reminder.edge.id);
    if (frameEdge) {
      return { kind: "log_touchpoint", edge: frameEdge };
    }
  }

  return {
    kind: "open_frame",
    frameRecordId: reminder.edge.frameRecordId,
    nodeId: reminderCounterpartNodeId(reminder, selectedNodeId)
  };
}

export function reminderCounterpartNodeId(reminder: GraphRelationshipReminder, selectedNodeId: string) {
  return reminder.edge.source === selectedNodeId ? reminder.edge.target : reminder.edge.source;
}
